import type { Message, MessageParams, ChatFileMessage, MessageEngine } from '@/data/chat/Message';
import HttpRequest from "@/services/request";
import {AITranslateApi} from "@/services/api"
import AIMessageObserver from "@/data/AIChatObserver" 

// ===== AI 文本翻译引擎写死配置 =====
// 收录白名单：命中的引擎才会进入可选列表(modeMap)。
const AI_TRANSLATE_ENGINE_WHITELIST = ['gpt-4o-mini', 'deepseek-v4-flash']
// 默认引擎优先级：按顺序取第一个"实际被收录(可见)"的引擎作为默认，
// 而非固定死某一个——gpt-4o-mini 若被后端隐藏(showFlag 不可见)则自动回退到 deepseek-v4-flash。
const AI_TRANSLATE_DEFAULT_ENGINE_PRIORITY = ['gpt-4o-mini', 'deepseek-v4-flash']

type DrakParams = {
  choiceWordsBizType?: number
  transOriginLangCode?: string
  transTargetLangCode?: string
}

type SendMessageParams = {
  questionText: string
  chatId: number
  aiEngine: string
  langCode: string
  choiceWordsBizType?: number
  transOriginLangCode?: string
  transTargetLangCode?: string
  forceTrialFlag?: number
}

type SendAIMessageParams = {
  originText: string
  bizType: number
  sourceLang: string
  targetLang: string
  aiEngineName: string
  chatId?: number
  forceTrialFlag?: number
  translateTagType?: number
}

type MindmapResponse = {
  mindMapImgUrl?: string
  [key: string]: any
}

function createEmptyMessageEngine(): MessageEngine {
  return {
    engineName: '',
    engineShowName: '',
    highLevelFlag: 0,
    iconImgUrl: '',
    tokenCostRatio: '',
    userDefaultFlag: 0,
    vipDefaultFlag: 0,
    engineKey: '',
    showFlag: 0,
    sort: 0,
  }
}

export class ChatMessage {
  private messages: Message[] = []; // 存储所有消息
  private params: MessageParams = {pageSize: 10}
  private chatFileMessage: ChatFileMessage = {
    docIds: 0,
    chatName: '',
    createTime: '',
    fileName: '',
    id: 0,
    operateRecordId: 0,
    namespace: '',
    renewMsgTime: '',
    tmpVisitorToken: '',
    updateTime: '',
    yetInitFlag: 0,
    userId: 0,
    costUserTokens: 0
  }; // 存储所有消息
  private remainCharsNum: number = 0 // 剩余可用字符数
  private remainTrialNum: number = 0 // 试用次数
  private isNeedHistoryMax: boolean = false // 是否已经加载最大
  private isRequestRefresh: boolean = false
  
  private modeMap: Record<string, MessageEngine> = {}
  private defaultUserMode: MessageEngine = createEmptyMessageEngine()
  private defaultVipMode: MessageEngine = createEmptyMessageEngine()
  private currentEngineMessage: MessageEngine = createEmptyMessageEngine()

  private currentLangCode = "" 
  private aiMessageObserver: AIMessageObserver = new AIMessageObserver()


  // 发送消息
  sendMessage(content: string, forceTrialFlag: boolean = false ,drakParams?: DrakParams): void {
    const params: SendMessageParams = {
      questionText: content,
      chatId: this.chatFileMessage.id,
      aiEngine: this.currentEngineMessage.engineName,
      langCode: this.currentLangCode
    }
    
    // 划词类型，如果划词， 这个参数肯定有
    if( drakParams && drakParams.choiceWordsBizType ) {
      params['choiceWordsBizType'] = drakParams.choiceWordsBizType
    }
    // 划词只有翻译是才有目标语言与源语言
    if( drakParams && drakParams.transTargetLangCode ){
      params['transOriginLangCode'] = drakParams.transOriginLangCode
      params['transTargetLangCode'] = drakParams.transTargetLangCode
    }
    if(forceTrialFlag) {
      params.forceTrialFlag = 1
    }
    this.openAIObserver(params)
    // requestHttpTranslate.post<ResultData>(sendAIChatMessage,params).then((result) => {
    //   if (result && result.code == '1'){
    //     console.log("sendMessage=======》", result)
    //     let aiChatMessage = result.data?.aiChatMessage
    //     let msgContent = result.data?.aiChatMessage.msgContent
    //     if (msgContent) {
    //       let newMsgJson = JSON.parse(msgContent)
    //       aiChatMessage.msgJsonContent = newMsgJson
    //     }
    //     aiChatMessage.isAnimation = true
    //     aiChatMessage.msgType = 1
    //     this.remainCharsNum = result.data?.remainCharsNum
    //     this.remainTrialNum = result.data?.remainTrialNum
    //     this.chatFileMessage.costTokens = result.data?.costTokens
    //     successCall(aiChatMessage)
    //   }else {
    //     failCall(result, content)
    //   }
    // }).catch((error)=>{
    //     console.log("error",error)

    //     failCall(error)
    // })
  }
  // 加载历史
  loadingMessageHistory(successCall: ([]) => void, failCall: () => void, isAiTranslate: boolean = false): void {
    if (this.isRequestRefresh) {
      return
    }
    this.isRequestRefresh = true
    HttpRequest.post<any>(isAiTranslate ? AITranslateApi.getAITranslateChatMessagesApi : AITranslateApi.getAIChatMessage,this.params).then((result) => {
      if (result && result.code == '1'){
        let chatMessages: Message[] = result.list || []
        console.log("loadingMessageHistory", chatMessages, this.params)
        if (chatMessages.length == this.params.pageSize) {
          this.params.prevPageId = chatMessages[0].id
        }else {
          this.isNeedHistoryMax = true
        }
        chatMessages.forEach((element, index) => {
          let msgContent = chatMessages[index].msgContent
          if (msgContent) {
            let newMsgJson = JSON.parse(msgContent)
            chatMessages[index].msgJsonContent = newMsgJson
          }
          chatMessages[index].isAnimation = false
          chatMessages[index].msgType = 1
        });
        successCall(chatMessages)
      }
      this.isRequestRefresh = false
    }).catch((error)=>{
        console.log("error",error)
        failCall()
        this.isRequestRefresh = false
    })
  }

  deleteAllMessage(successCall: () => void, failCall: () => void): void {
    HttpRequest.post<any>(AITranslateApi.deleteAIChatMessage,{chatId: this.params.chatId}).then((result) => {
      if (result && result.code == '1'){
        this.clearMessages()
        successCall()
      }else {
        failCall()
      }
    }).catch((error)=>{
        console.log("error",error)
        failCall()
    })
  }

  // 接收消息
  receiveMessage(message: Message): void {
    this.messages.push(message);
    console.log('Message received:', message);
  }

  // 获取所有消息
  getAllMessages(): Message[] {
    return this.messages;
  }

  // 获取当前加载状态 
  getCheckLoadingCompleted(): boolean {
    return this.isNeedHistoryMax;
  }

  // 获取当前引擎信息
  getModeByKey(key: string): MessageEngine {
    return this.modeMap[key]
  }

  getUserModeInfo(): MessageEngine {
    return this.defaultUserMode
  }

  getVipModeInfo(): MessageEngine {
    return this.defaultVipMode
  }

  getAllModeInfo(): object {
    return this.modeMap
  }

  setLangCode(code: string): void {
    this.currentLangCode = code
  }

  getLangCode(): string {
    return this.currentLangCode
  }

  getAIInfo() :ChatFileMessage {
    return this.chatFileMessage
  }

  getAIChatId() :number {
    return this.params.chatId ?? 0
  }
  
  setAIChatId(chatId: number) {
    console.log('setAIChatId==', chatId)
    this.params.chatId = chatId
  }

  resetParams() {
    this.params.chatId = undefined
    this.params.prevPageId = undefined
    this.params.nextPageId = undefined
    this.params.pageSize = 10
  }
  
  // 清空消息
  clearMessages(): void {
    this.messages = [];
    this.params.prevPageId = undefined
    console.log('All messages cleared.');
  }

  createWelcomeMessage(welcomeText: string = "", content: string = "") : Message[] {
    let messages: Message[] = []
    if (welcomeText && welcomeText.length > 0) {
      let tempMessage: Message = {
        chatId: -3, 
        msgContent: JSON.stringify({ text: welcomeText }), 
        msgJsonContent: { text: welcomeText }, 
        isAnimation: false, 
        aiRespFlag: 1,
        createTime: "",
        costCharsNum: 0,
        fileDocIds: "",
        id: 0,
        operateRecordId: 0,
        tmpVisitorToken: "",
        updateTime: "",
        userId: 0,
        msgType: 1,
      }
      messages.push(tempMessage);
    }
    if (content && content.length > 0) {
      let questionMessage: Message = {
          chatId: -2, 
          isAnimation: false, 
          aiRespFlag: 1,
          msgContent: JSON.stringify({ text: content }), 
          msgJsonContent: {text: content},
          createTime: "",
          costCharsNum: 0,
          fileDocIds: "",
          id: 0,
          operateRecordId: 0,
          tmpVisitorToken: "",
          updateTime: "",
          userId: 0,
          msgType: 1,
      }
      messages.push(questionMessage);
    }
    return messages
  }

  getRemainNumInfo():  {remainCharsNum: number; remainTrialNum: number; remainCharsAll: number} {
    return {remainCharsNum: this.remainCharsNum, remainTrialNum: this.remainTrialNum, remainCharsAll: this.chatFileMessage.costUserTokens}
  }

  setRemainNumInfo(remainCharsNum: number, remainTrialNum: number, remainCharsAll: number): void{
    this.remainCharsNum = remainCharsNum
    this.remainTrialNum = remainTrialNum
    this.chatFileMessage.costUserTokens = remainCharsAll
  }

  updataEngine(engine: MessageEngine): void {
    console.log("updataEngine", engine)
    this.currentEngineMessage = engine
  }
  
  initMessageList(operateRecordId: number, call: () => void, failCall: () => void): void {
    console.log("initMessageList", operateRecordId)
    HttpRequest.post<any>(AITranslateApi.getAIOpenChatMessageList,{operateRecordId: operateRecordId}).then((result) => {
        if (result && result.code == '1'){
          console.log("initMessageList", result)
          this.chatFileMessage = result.data?.curAiChatInfo
          this.messages = result.data?.chatMessageList || []
          this.messages.forEach((element, index) => {
            let msgContent = this.messages[index].msgContent
            let aiRespFlag = this.messages[index].aiRespFlag // 0 自己发的 1 普通ai回答消息 2 ai校对消息
            if (msgContent) {
              console.log("msgContent", typeof msgContent)
              let newMsgJson = aiRespFlag == 2 ? msgContent : JSON.parse(msgContent)
              this.messages[index].msgJsonContent = newMsgJson
            }
            this.messages[index].isAnimation = false
            this.messages[index].msgType = 1
          });
          this.params.chatId = this.chatFileMessage.id
          if (this.messages.length == this.params.pageSize) {
            this.params.prevPageId = this.messages[0].id
          }else {
            this.isNeedHistoryMax = true
          }
          this.remainCharsNum = result.data?.remainCharsNum
          this.remainTrialNum = result.data?.remainTrialNum
          call()
        }else {
          failCall()
        }
    }).catch((error)=>{
        console.log("error",error)
        
        failCall()
    })
  }

  getInitAIChatEngines(successCall: () => void, failCall: () => void, isAiTranslate: boolean = false, userInfo: any = null) {
    HttpRequest.get<any>(AITranslateApi.getAIChatEngines, null).then((result) => {
      if (result && result.code == '1'){
        for (const key in result.data) {
          const element = result.data[key];
          // 如果是AI 文本翻译过来的
          if (isAiTranslate) {
            if (userInfo && (userInfo.vipLevel > 0 || userInfo.validWordsForBag > 0)) {
              if (element.showFlag == 2 || element.showFlag == 3 || element.showFlag == -1) {
                // 白名单内、且后端标记可见(showFlag∈{2,3,-1})的引擎才进可选列表
                if (AI_TRANSLATE_ENGINE_WHITELIST.includes(element.engineName)) {
                  this.modeMap[key] = element
                  this.modeMap[key].engineKey = key
                }
                // if (element.engineName == 'glm-4.5-flash' || element.engineName == 'gpt-5-nano') {
                //   this.modeMap[key] = element 
                //   this.modeMap[key].engineKey = key
                //   if (element.engineName == 'glm-4.5-flash') {
                //     this.defaultUserMode = element
                //   }
                //   if (element.engineName == 'gpt-5-nano') {
                //     this.defaultVipMode = element
                //   }
                // }
                // this.modeMap[key] = element 
                // this.modeMap[key].engineKey = key
                // if (element.userDefaultFlag) {
                //   this.defaultUserMode = element
                // }
                // if (element.vipDefaultFlag) {
                //   this.defaultVipMode = element
                // }
              }
            }else {
              if (element.showFlag == 2 || element.showFlag == 3 || element.showFlag == -1) {
                // 白名单内、且后端标记可见(showFlag∈{2,3,-1})的引擎才进可选列表
                if (AI_TRANSLATE_ENGINE_WHITELIST.includes(element.engineName)) {
                  this.modeMap[key] = element
                  this.modeMap[key].engineKey = key
                }
                // 这里免费引擎 才收录
                // if (element.highLevelFlag == 0){
                //   this.modeMap[key] = element 
                //   this.modeMap[key].engineKey = key
                //   if (element.userDefaultFlag) {
                //     this.defaultUserMode = element
                //   }
                // }
              }
            }
            // if (element.showFlag == 2 || element.showFlag == 3 || element.showFlag == -1) {
            //   this.modeMap[key] = element 
            //   this.modeMap[key].engineKey = key
            //   if (element.userDefaultFlag) {
            //     this.defaultUserMode = element
            //   }
            //   if (element.vipDefaultFlag) {
            //     this.defaultVipMode = element
            //   }
            // }
          }else {
            if (element.showFlag == 1 || element.showFlag == 3 || element.showFlag == -1) {
              this.modeMap[key] = element 
              this.modeMap[key].engineKey = key
              if (element.userDefaultFlag) {
                this.defaultUserMode = element
              }
              if (element.vipDefaultFlag) {
                this.defaultVipMode = element
              }
            }
          }
        }
        // AI 文本翻译：遍历结束后按优先级挑默认引擎——取第一个"实际被收录(可见)"的，
        // gpt-4o-mini 优先，被后端隐藏则回退 deepseek-v4-flash，确保默认引擎不会为空。
        if (isAiTranslate) {
          const recordedEngines = Object.values(this.modeMap)
          const isVip = !!(userInfo && (userInfo.vipLevel > 0 || userInfo.validWordsForBag > 0))
          for (const engineName of AI_TRANSLATE_DEFAULT_ENGINE_PRIORITY) {
            const hitEngine: any = recordedEngines.find((item: any) => item.engineName === engineName)
            if (hitEngine) {
              this.defaultUserMode = hitEngine
              if (isVip) this.defaultVipMode = hitEngine
              break
            }
          }
        }
        successCall()
      }else {
        failCall()
      }
    }).catch((error)=>{
        console.log("error",error)
        failCall()
    })
  }

  getRequestGenerateMindmap(messageParams: Record<string, any>, successCall: (data: MindmapResponse) => void, failCall: () => void) {
    HttpRequest.post<any>(AITranslateApi.getGenerateMindmap, messageParams).then((result) => {
      if (result && result.code == '1'){
        successCall(result.data)
      }else {
        failCall()
      }
    }).catch((error)=>{
        console.log("error",error)
        failCall()
    })
  }

  openAIObserver(param: SendMessageParams | SendAIMessageParams, isAiTranslate: boolean = false) :void{
    this.aiMessageObserver.connect(param, isAiTranslate)
  }

  closeAIObserver() :void{
    this.aiMessageObserver.closeEventSource()
  }


  // ai 相关  chatId 为虚拟的chatId
  sendAIMessage(content: string, sourceLang: string, targetLang: string, forceTrialFlag: boolean = false, translateTagType: number = 0, chatId?: number): void {
    const params: SendAIMessageParams = {
      originText: content,
      bizType: 1,  // 默认业务1 ai 翻译 后续接入别的类型在传入
      sourceLang: sourceLang,
      targetLang: targetLang,
      aiEngineName: this.currentEngineMessage.engineName
    }
    console.log('chatIdchatId==', chatId)
    // 这里如果传入了 虚拟的chatId 则不使用当前的chatId
    if (this.params.chatId && !chatId) {
      params.chatId = this.params.chatId
    }

    if(forceTrialFlag) {
      params.forceTrialFlag = 1
    }

    if (translateTagType > 0) {
      params.translateTagType = translateTagType
    }
    this.openAIObserver(params, true)
    // requestHttpTranslate.post<ResultData>(sendAIChatMessage,params).then((result) => {
    //   if (result && result.code == '1'){
    //     console.log("sendMessage=======》", result)
    //     let aiChatMessage = result.data?.aiChatMessage
    //     let msgContent = result.data?.aiChatMessage.msgContent
    //     if (msgContent) {
    //       let newMsgJson = JSON.parse(msgContent)
    //       aiChatMessage.msgJsonContent = newMsgJson
    //     }
    //     aiChatMessage.isAnimation = true
    //     aiChatMessage.msgType = 1
    //     this.remainCharsNum = result.data?.remainCharsNum
    //     this.remainTrialNum = result.data?.remainTrialNum
    //     this.chatFileMessage.costTokens = result.data?.costTokens
    //     successCall(aiChatMessage)
    //   }else {
    //     failCall(result, content)
    //   }
    // }).catch((error)=>{
    //     console.log("error",error)

    //     failCall(error)
    // })
  }

  // 重新加载ai对话
  reloadAIMessage(operateRecordId: number, successCall: () => void, failCall: () => void) {
    HttpRequest.post<any>(AITranslateApi.getAIChatReloadMessage, {operateRecordId: operateRecordId}).then((result) => {
      if (result && result.code == '1'){
        this.chatFileMessage = result.data?.curAiChatInfo
        this.messages = []
        this.params.chatId = this.chatFileMessage.id
        this.isNeedHistoryMax = true
        
        this.remainCharsNum = result.data?.remainCharsNum
        this.remainTrialNum = result.data?.remainTrialNum
        successCall()
      }else {
        failCall()
      }
    }).catch((error)=>{
        console.log("error",error)
        failCall()
    })
  }
}